export default __webpack_public_path__ + "static/PurpleFibreHero-a949f71af6620dbed43f061441e74ea6.png";